"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildArray = void 0;
/**
 * @internal
 * Returns an array of the given size filled with element built from the given constructor and the paramters
 * @param size - the number of element to construct and put in the array
 * @param itemBuilder - a callback responsible for creating new instance of item. Called once per array entry.
 * @returns a new array filled with new objects
 * @internal
 */
function buildArray(size, itemBuilder) {
    const a = [];
    for (let i = 0; i < size; ++i) {
        a.push(itemBuilder());
    }
    return a;
}
exports.buildArray = buildArray;
//# sourceMappingURL=utils.js.map